import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type ForumEntityClassJSON = z.infer<typeof ForumEntityClassSchema.ForumEntityClassJSONZ>;
export type ForumEntityClassParams = z.infer<typeof ForumEntityClassSchema.ForumEntityClassZ>;

export default class ForumEntityClassSchema {
  public static readonly ForumEntityClassJSONZ = z.string().min(1);
  public static readonly ForumEntityClassZ = z.string().min(1);

  public static validate(value: unknown, logError: boolean = true): ForumEntityClassParams {
    return parseOrThrow(ForumEntityClassSchema.ForumEntityClassZ, value, {
      logError,
      schemaName: "ForumEntityClassSchema",
      operation: "validate",
      payloadSample: value,
    });
  }

  public static validateJSON(values: unknown): ForumEntityClassParams {
    return parseOrThrow(ForumEntityClassSchema.ForumEntityClassZ, values, {
      logError: true,
      schemaName: "ForumEntityClassSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is ForumEntityClassParams {
    try {
      ForumEntityClassSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: unknown): ForumEntityClassParams {
    return parseOrThrow(ForumEntityClassSchema.ForumEntityClassZ, data, {
      logError: true,
      schemaName: "ForumEntityClassSchema",
      operation: "deserialize",
      payloadSample: data,
    });
  }

  public static serialize(data: ForumEntityClassParams): ForumEntityClassJSON {
    const parsed = ForumEntityClassSchema.validateJSON(data);
    return ForumEntityClassSchema.codec.encode(parsed);
  }

  public static readonly codec = z.codec(
    ForumEntityClassSchema.ForumEntityClassJSONZ,
    ForumEntityClassSchema.ForumEntityClassZ,
    {
      decode: (data) => z.string().min(1).parse(data),
      encode: (forumEntityClass) => z.string().min(1).parse(forumEntityClass),
    }
  );
}
